export default "__VITE_ASSET__DjYB9c6Q__"